// extracted by mini-css-extract-plugin
export default {"markdown":"ReactMarkdownLazy_markdown__rulKw"};